import React, { useMemo } from "react";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import { BlockRecord } from "models/view-models/block-record";
import ChecklistBlockContent from "molecules/page-block-content/checklist-block-content";
import CodeReferenceBlockContent from "molecules/page-block-content/code-reference-block-content";
import TextBlockContent from "molecules/page-block-content/text-block-content";
import { AdditionalBlockData } from "models/interfaces/additional-block-data/additional-block-data";
import ImageBlockContent from "./image-block/image-block-content";

export interface PageBlockContentProps {
    block: BlockRecord;
    additionalBlockData: AdditionalBlockData;
    onBlockSaved: (updatedBlock: BlockRecord) => void;
    printable?: boolean;
}

const BLOCK_TYPE_TO_CONTENT_COMPONENT_MAP: Record<
    NotebookPageContentBlock,
    React.FC<PageBlockContentProps>
> = {
    [NotebookPageContentBlock.Text]: TextBlockContent,
    [NotebookPageContentBlock.CodeReference]: CodeReferenceBlockContent,
    [NotebookPageContentBlock.Checklist]: ChecklistBlockContent,
    [NotebookPageContentBlock.Image]: ImageBlockContent,
};

export const PageBlockContent: React.FC<PageBlockContentProps> = (
    props: PageBlockContentProps
): JSX.Element => {
    const ContentComponent = useMemo(
        () => BLOCK_TYPE_TO_CONTENT_COMPONENT_MAP[props.block.type],
        [props.block.type]
    );

    return (
        <ContentComponent
            {...props}
            additionalBlockData={props.additionalBlockData}
        />
    );
};
